
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
// All button labels should be passed in as arguments from the parent/component, not translated here.

export function usePriceOverrideEffect({
    isPriceOverride,
    myCaseResourceType,
    setPriceOverrideTableData,
    filteredProduct,
    getModifiedButtonVisibilities,
    footerButtonStatuses,
    showReportPayment,
    replenish,
    setFooterButtonStatuses,
    dispatch,
    setPriceOverridePage,
    reportPaymentScreenName,
    review,
    next,
    submit,
    replenishmentPageVisibilityUsage,
    procedurePageVisibility,
    procedure,
    apply,
    currentActivity,
    usageDetails
}) {
    useEffectWithErrorLogging(() => {
        let modifiedButtonStatuses = [...footerButtonStatuses];
        if (isPriceOverride) {
            if (myCaseResourceType !== 'reportPayment' && !showReportPayment) {
                setPriceOverrideTableData(
                    filteredProduct.filter((item) => !item.accountOwned)
                );
            }
            modifiedButtonStatuses = getModifiedButtonVisibilities(
                myCaseResourceType,
                footerButtonStatuses,
                showReportPayment ? review : replenishmentPageVisibilityUsage ? replenish : procedurePageVisibility ? procedure : review,
                apply

            );
            setFooterButtonStatuses(modifiedButtonStatuses);
            dispatch(setPriceOverridePage(true));
        } else {
            setFooterButtonStatuses((prevState) =>
                getModifiedButtonVisibilities(
                    myCaseResourceType,
                    prevState,
                    apply,
                    myCaseResourceType === 'reportPayment'
                        ? reportPaymentScreenName === 'Review'
                            ? submit
                            : next
                        : showReportPayment
                            ? review
                            :replenishmentPageVisibilityUsage && currentActivity === 'Record' ? replenish : procedurePageVisibility && currentActivity === 'Replen' ? procedure : procedurePageVisibility && currentActivity === 'Procedure' ?(!(usageDetails &&usageDetails.unidId &&
            usageDetails?.unidSurgeryInfoPage?.deliveredRodItems?.length > 0))&& review:currentActivity !== 'Submit'&& review
                )
            );
        }
    }, [isPriceOverride]);
}
